export class HealthDenialReason {
  code: string;
  id: number;
  name: string;
}
